<template>
  <div class="w-100 d-flex flex-column justify-content-between">
    <div
      v-for="[key, quiz] in Object.entries(steps)"
      :key="key.key"
      class="w-100 d-flex flex-column"
    >
      <template v-if="currentStep == key">
        <div class="text-large text-primary">
          {{ quiz.question }}
        </div>
  
        <!-- inputs [auto-generate] -->
        <div class="mt-2 w-50">
          <template v-if="quiz.inputType == 'text'">
            <b-input
              v-model="quizAnswers[key]"
              :placeholder="quiz.placeholder"
              autofocus
            />
          </template>

          <template v-if="quiz.inputType == 'select-multiple'">
            <v-select
              v-model="quizAnswers[key]"
              :options="quiz.options"
              :placeholder="quiz.placeholder"
              :reduce="option => option.value"
              class="w-100"
              label="text"
              multiple
            >
              <template #selected-option="option">
                <div>
                  <b class="text-light">{{ option.text }}</b>
                </div>
              </template>

              <template #option="option">
                <div>
                  <b>{{ option.text }}</b>
                </div>
              </template>
            </v-select>
          </template>

          <template v-if="quiz.inputType == 'b-form-tags'">
            <b-form-tags
              v-model="quizAnswers[key]"
              :placeholder="quiz.placeholder"
              :tag-validator="quiz.validator"
              input-id="tags-basic"
              class="w-100"
              remove-on-delete
              autofocus
            />
          </template>
        </div>
      </template>

    </div>

    <div class="mt-4 d-flex flex-row justify-content-between">
      <div class="d-flex flex-row flex-gap-md">
        <b-button
          v-if="currentStep != stepsArray.at(0)"
          variant="outline-primary"
          @click="prevStep"
        >Previous</b-button>
  
        <b-button
          v-if="currentStep != stepsArray.at(-1)"
          variant="primary"
          @click="nextStep"
        >Next</b-button>
  
        <b-button
          v-if="currentStep == stepsArray.at(-1)"
          variant="primary"
          @click="submitForm"
        >Submit</b-button>
      </div>

      <div class="bg-dar">
        <b-button
          variant="outline-danger"
          @click="$emit('close', true)"
        >Skip</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentStep: null,
      steps: {
        last_job_position: {
          label: 'Last Job Position',
          question: 'What is your current / recent job position?',
          description: 'What is your current / recent job position?',
          inputType: 'text',
          placeholder: 'Type in position title'
        },

        skills: {
          label: 'skills',
          question: 'Let us know of the skills you possess',
          description: 'What is your current / recent job position?',
          inputType: 'b-form-tags',
          placeholder: 'Press enter after adding each skill',
          validator: (tag) => {
            const checkedTag = this.$validateGeneralAcceptedString(tag)
            return checkedTag.state
          }, 
        },
      },
      stepsArray: [], // auto-assign on initComponent, bsing from this.steps 

      quizAnswers: {},
    }
  },

  mounted() {
    this.initComponent()
  },

  methods: {
    initComponent() {
      this.stepsArray = Object.keys(this.steps)
      this.currentStep = this.stepsArray.at(0)
    },

    submitForm() {
      this.$emit('form-submit', this.quizAnswers)
    },

    prevStep() {
      const stepNumber = this.stepsArray.indexOf(this.currentStep) -1
      this.currentStep = this.stepsArray[stepNumber]
    },

    nextStep() {
      const stepNumber = this.stepsArray.indexOf(this.currentStep) +1
      this.currentStep = this.stepsArray[stepNumber]
    },
  },
}
</script>

<style lang="scss" scoped>
.vs-select {
  &:not(.vs--single) {
    .vs__selected {
      fill:white !important;
      svg {
        fill: white !important;
        line {
          fill: white !important;
        }
      }
    }
  }
}
</style>